exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:767px){.phx-page-header .header-extra>*{width:100%!important}}.mobile-select-custom-styles .phx-select-option-content{padding-top:0!important;padding-bottom:0!important}.mobile-select-custom-styles.has-group-option .phx-select-option-item:nth-child(2):not(:last-child){pointer-events:none}.group-filter-container .dropdown-trigger{min-width:0}", ""]);

// exports
